import { commentator } from "@utilities/sal-commentator/sal-commentator";

let cookieUtils;
cookieUtils = {
    constants: {
        DAYS: 60 * 60 * 24,
        HOURS: 60 * 60,
        MINUTES: 60
    },
    setCookie: (key, value, maxAge = cookieUtils.constants.DAYS * 30, secure = true, samesite = true, expirationDate = null, cookieDomain = null) => {
        try {
            let cookieValue = `${value ? encodeURIComponent(value) : ''}`;
            if (expirationDate) {
                cookieValue += `;expires=${expirationDate}`;
            } else {
                cookieValue += maxAge ? `;max-age=${encodeURIComponent(maxAge)}` : '';
            }
            cookieValue += '; path=/';
            cookieValue += cookieDomain ? `;domain=${cookieDomain}` : '';
            cookieValue += secure ? `;secure` : '';
            cookieValue += samesite ? `;samesite=lax` : '';
            document.cookie = `${key}=${cookieValue}`;
            return true
        } catch (e) {
            commentator.insertCommentBefore(document.body, `cookie-utils.js \n ${e}`, commentator.getPresets().ERROR);
            return false
        }
    },
    getCookie: (key) => {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + key + '=');
        return parts.length < 2
            ? undefined
            : parts
                .pop()
                .split(';')
                .shift();
    },
    deleteCookie: (key, cookieDomain = null) => {
        try {
            cookieUtils.setCookie(key, 'deleted', null, true, true, new Date(0).toUTCString(), cookieDomain);
            return true
        } catch (e) {
            commentator.insertCommentBefore(document.body, `cookie-utils.js \n ${e}`, commentator.getPresets().ERROR);
            return false
        }
    },
    addCookieValue: (key, value, maxAge = cookieUtils.constants.DAYS * 30, secure = true, samesite = true, expirationDate = null, cookieDomain = null) => {
        const valueArray = cookieUtils.decodeCookieValue(cookieUtils.getCookie(key));
        if (valueArray) {
            if (valueArray.includes(value)) {
                return true;
            }
            valueArray.push(value);
            return cookieUtils.setCookie(key, valueArray.join('$'), maxAge, secure, samesite, expirationDate, cookieDomain)
        } else {
            return cookieUtils.setCookie(key, value, maxAge, secure, samesite, expirationDate, cookieDomain);
        }
    },
    removeCookieValue: (key, value, maxAge = cookieUtils.constants.DAYS * 30, secure = true, samesite = true, expirationDate = null, cookieDomain = null) => {
        const values = cookieUtils.decodeCookieValue(cookieUtils.getCookie(key));
        const index = values.findIndex(el => el === value);
        if (index >= 0) {
            values.splice(index, 1);
            if (values.length) {
                return cookieUtils.setCookie(key, values.join('$'), maxAge, secure, samesite, expirationDate, cookieDomain);
            } else {
                return cookieUtils.deleteCookie(key, cookieDomain);
            }
        }
    },
    isValueInKey: (key, value) => {
        const values = cookieUtils.decodeCookieValue(cookieUtils.getCookie(key));
        if (values) {
            return values.findIndex(el => el === value) !== -1;
        } else {
            return false;
        }
    },
    cookieValueLength: (key) => {
        const values = cookieUtils.decodeCookieValue(cookieUtils.getCookie(key));
        return values !== undefined ? values.length : 0
    },
    decodeCookieValue: (value) => {
        if (value !== undefined) {
            return decodeURIComponent(value).split('$');
        } else {
            return undefined;
        }
    }
};

export { cookieUtils };
